import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BookOpen, Flag, Layers, MapPinned, ShieldCheck, Users, Tag } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@ooh/ui/components/card';

interface AdminCard {
  icon: React.ReactNode;
  title: string;
  description: string;
  to: string;
}

function AdminCardItem({ icon, title, description, to }: AdminCard) {
  return (
    <Link to={to} className="block group">
      <Card className="h-full transition-shadow hover:shadow-md cursor-pointer border-border/60">
        <CardHeader>
          <CardTitle className="flex items-center gap-3 text-[15px]">
            {icon}
            {title}
          </CardTitle>
          <CardDescription className="text-[13px]">{description}</CardDescription>
        </CardHeader>
      </Card>
    </Link>
  );
}

export function AdminLandingCards() {
  const { t } = useTranslation('common');
  return (
    <section className="p-6 max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
      <AdminCardItem
        icon={<Users className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.users.title')}
        description={t('adminLanding.users.description')}
        to="/admin/users"
      />
      <AdminCardItem
        icon={<ShieldCheck className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.permissions.title')}
        description={t('adminLanding.permissions.description')}
        to="/admin/permissions"
      />
      <AdminCardItem
        icon={<BookOpen className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.dictionaries.title')}
        description={t('adminLanding.dictionaries.description')}
        to="/admin/dictionaries/formats"
      />
      <AdminCardItem
        icon={<Layers className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.formatGroups.title')}
        description={t('adminLanding.formatGroups.description')}
        to="/admin/dictionaries/format-groups"
      />
      <AdminCardItem
        icon={<MapPinned className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.pois.title')}
        description={t('adminLanding.pois.description')}
        to="/admin/pois"
      />
      <AdminCardItem
        icon={<Tag className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.tags.title')}
        description={t('adminLanding.tags.description')}
        to="/admin/dictionaries/tags"
      />
      <AdminCardItem
        icon={<Flag className="h-5 w-5 text-primary shrink-0" strokeWidth={1.8} />}
        title={t('adminLanding.featureFlags.title')}
        description={t('adminLanding.featureFlags.description')}
        to="/admin/feature-flags"
      />
    </section>
  );
}
